// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AX24I4GTVSIZ8aNDMM8s,
.AgP8zoxMbCnjDhCf9ELr,
.q_9ga7W1BCj5YRkZeIxD,
.qx6GmxhovO3dGrzsi0Un {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1.2rem;
}
.AX24I4GTVSIZ8aNDMM8s {
    padding: 0 0 0.8rem;
    border-bottom: 1px solid var(--mark-border);
    margin-bottom: 0;
}
.AX24I4GTVSIZ8aNDMM8s h3,
.zYcbs700oSbiLacHumlU h3 {
    margin: 0;
    font-size: 1.8rem;
}
.AX24I4GTVSIZ8aNDMM8s p,
.zYcbs700oSbiLacHumlU p {
    margin: 0.8rem 0 0;
}
.Q_5zHdQihq1lJsiMIQ_z {
    color: var(--mark-muted);
    font-size: 1.4rem;
    line-height: 1.6;
    overflow-wrap: anywhere;
}
.zYcbs700oSbiLacHumlU {
    min-width: 0;
    margin-bottom: 2.4rem;
}
.q3_IflU1mthdpbxHTfrh {
    display: grid;
    grid-template-columns: minmax(24rem, 1fr) minmax(0, 2fr);
    border: 1px solid var(--mark-border);
    border-radius: 1.2rem;
    margin-top: 1.6rem;
    overflow: hidden;
}
.qc25NC2dJkfVZMAdVz88 {
    padding: 1.6rem;
    border-right: 1px solid var(--mark-border);
    min-width: 0;
}
.vIi6OVCrPHJQPoVmw92R {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin-bottom: 1.6rem;
}
.ElQt_fivKfE1DPKR0h6y {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    width: 100%;
    text-align: left;
    font: inherit;
    color: var(--mark-text);
    background: var(--mark-surface);
    border: 1px solid var(--mark-border);
    border-radius: 0.8rem;
    padding: 1.6rem;
    margin-top: 0.8rem;
    cursor: pointer;
    overflow-wrap: anywhere;
}
.AgP8zoxMbCnjDhCf9ELr {
    width: 100%;
    flex-wrap: nowrap;
    align-items: flex-start;
}
.AgP8zoxMbCnjDhCf9ELr strong {
    min-width: 0;
}
.VF6BhIuQc4a4rOv3wjeQ {
    font-size: 1.2rem;
    color: var(--mark-muted);
    border: 1px solid var(--mark-border);
    border-radius: 0.4rem;
    padding: 0.2rem 0.6rem;
    flex-shrink: 0;
}
.ElQt_fivKfE1DPKR0h6y[aria-pressed='true'] {
    border-color: var(--mark-primary);
    background: var(--mark-selected);
}
.ElQt_fivKfE1DPKR0h6y:hover {
    border-color: var(--mark-primary);
}
.ElQt_fivKfE1DPKR0h6y:focus-visible {
    outline: 2px solid var(--mark-primary);
    outline-offset: 2px;
}
.iL71IHzx41ahjiCyd2qK {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    padding: 2.4rem;
    min-width: 0;
    overflow-wrap: anywhere;
}
.SJSjjQL__AZ9FPjzKO8Q {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 40rem;
    text-align: center;
    color: var(--mark-muted);
}

.q_9ga7W1BCj5YRkZeIxD {
    margin-top: 1.6rem;
    font-size: 1.3rem;
}
.qx6GmxhovO3dGrzsi0Un {
    border-top: 1px solid var(--mark-border);
    padding-top: 1.6rem;
}
.qx6GmxhovO3dGrzsi0Un p {
    flex: 1;
    min-width: min(100%, 20rem);
}
.CYPTmuurDeg3Y2rE8GGQ {
    padding: 1.6rem;
    border-radius: 0.8rem;
    background: var(--mark-danger-surface);
    color: var(--mark-danger);
}
@media (max-width: 850px) {
    .q3_IflU1mthdpbxHTfrh {
        grid-template-columns: minmax(0, 1fr);
    }
    .qc25NC2dJkfVZMAdVz88 {
        border-right: 0;
        border-bottom: 1px solid var(--mark-border);
    }
    .iL71IHzx41ahjiCyd2qK {
        padding: 1.6rem;
    }
}

.UP7I6H0Hu7du7DVlmm1Q {
    margin-top: 1.2rem;
}

.iNCfQKhZqFc_omlF2Bl2 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.8rem;
    min-width: 0;
    border: 0;
    padding: 0;
    margin: 0;
}
.iNCfQKhZqFc_omlF2Bl2 .Q_swukO1eFeETY37WX99 {
    padding: 0.4rem 1rem;
    min-height: 3.6rem;
    gap: 0.6rem;
    border-width: 1px;
    border-radius: 0.6rem;
    font-size: 1.3rem;
}
`, "",{"version":3,"sources":["webpack://./pages/Mark/components/templateAuthoring.module.css"],"names":[],"mappings":"AAAA;;;;IAII,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;AACpB;AACA;;IAEI,SAAS;IACT,iBAAiB;AACrB;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,wDAAwD;IACxD,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,0CAA0C;IAC1C,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,+BAA+B;IAC/B,oCAAoC;IACpC,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,oCAAoC;IACpC,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,iCAAiC;IACjC,gCAAgC;AACpC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,sCAAsC;IACtC,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,wCAAwC;IACxC,mBAAmB;AACvB;AACA;IACI,OAAO;IACP,2BAA2B;AAC/B;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,sCAAsC;IACtC,yBAAyB;AAC7B;AACA;IACI;QACI,qCAAqC;IACzC;IACA;QACI,eAAe;QACf,2CAA2C;IAC/C;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;AACb;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;AACrB","sourcesContent":[".toolbar,\n.resultHeading,\n.pagination,\n.useTemplate {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1.2rem;\n}\n.toolbar {\n    padding: 0 0 0.8rem;\n    border-bottom: 1px solid var(--mark-border);\n    margin-bottom: 0;\n}\n.toolbar h3,\n.library h3 {\n    margin: 0;\n    font-size: 1.8rem;\n}\n.toolbar p,\n.library p {\n    margin: 0.8rem 0 0;\n}\n.hint {\n    color: var(--mark-muted);\n    font-size: 1.4rem;\n    line-height: 1.6;\n    overflow-wrap: anywhere;\n}\n.library {\n    min-width: 0;\n    margin-bottom: 2.4rem;\n}\n.browser {\n    display: grid;\n    grid-template-columns: minmax(24rem, 1fr) minmax(0, 2fr);\n    border: 1px solid var(--mark-border);\n    border-radius: 1.2rem;\n    margin-top: 1.6rem;\n    overflow: hidden;\n}\n.results {\n    padding: 1.6rem;\n    border-right: 1px solid var(--mark-border);\n    min-width: 0;\n}\n.field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    margin-bottom: 1.6rem;\n}\n.result {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    width: 100%;\n    text-align: left;\n    font: inherit;\n    color: var(--mark-text);\n    background: var(--mark-surface);\n    border: 1px solid var(--mark-border);\n    border-radius: 0.8rem;\n    padding: 1.6rem;\n    margin-top: 0.8rem;\n    cursor: pointer;\n    overflow-wrap: anywhere;\n}\n.resultHeading {\n    width: 100%;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n}\n.resultHeading strong {\n    min-width: 0;\n}\n.badge {\n    font-size: 1.2rem;\n    color: var(--mark-muted);\n    border: 1px solid var(--mark-border);\n    border-radius: 0.4rem;\n    padding: 0.2rem 0.6rem;\n    flex-shrink: 0;\n}\n.result[aria-pressed='true'] {\n    border-color: var(--mark-primary);\n    background: var(--mark-selected);\n}\n.result:hover {\n    border-color: var(--mark-primary);\n}\n.result:focus-visible {\n    outline: 2px solid var(--mark-primary);\n    outline-offset: 2px;\n}\n.selection {\n    display: flex;\n    flex-direction: column;\n    gap: 1.6rem;\n    padding: 2.4rem;\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n.previewEmpty {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-height: 40rem;\n    text-align: center;\n    color: var(--mark-muted);\n}\n\n.pagination {\n    margin-top: 1.6rem;\n    font-size: 1.3rem;\n}\n.useTemplate {\n    border-top: 1px solid var(--mark-border);\n    padding-top: 1.6rem;\n}\n.useTemplate p {\n    flex: 1;\n    min-width: min(100%, 20rem);\n}\n.notice {\n    padding: 1.6rem;\n    border-radius: 0.8rem;\n    background: var(--mark-danger-surface);\n    color: var(--mark-danger);\n}\n@media (max-width: 850px) {\n    .browser {\n        grid-template-columns: minmax(0, 1fr);\n    }\n    .results {\n        border-right: 0;\n        border-bottom: 1px solid var(--mark-border);\n    }\n    .selection {\n        padding: 1.6rem;\n    }\n}\n\n.editorBody {\n    margin-top: 1.2rem;\n}\n\n.formatChoices {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.8rem;\n    min-width: 0;\n    border: 0;\n    padding: 0;\n    margin: 0;\n}\n.formatChoices .formatChoice {\n    padding: 0.4rem 1rem;\n    min-height: 3.6rem;\n    gap: 0.6rem;\n    border-width: 1px;\n    border-radius: 0.6rem;\n    font-size: 1.3rem;\n}\n"],"sourceRoot":""}]);
// Exports
export var toolbar = `AX24I4GTVSIZ8aNDMM8s`;
export var resultHeading = `AgP8zoxMbCnjDhCf9ELr`;
export var pagination = `q_9ga7W1BCj5YRkZeIxD`;
export var useTemplate = `qx6GmxhovO3dGrzsi0Un`;
export var library = `zYcbs700oSbiLacHumlU`;
export var hint = `Q_5zHdQihq1lJsiMIQ_z`;
export var browser = `q3_IflU1mthdpbxHTfrh`;
export var results = `qc25NC2dJkfVZMAdVz88`;
export var field = `vIi6OVCrPHJQPoVmw92R`;
export var result = `ElQt_fivKfE1DPKR0h6y`;
export var badge = `VF6BhIuQc4a4rOv3wjeQ`;
export var selection = `iL71IHzx41ahjiCyd2qK`;
export var previewEmpty = `SJSjjQL__AZ9FPjzKO8Q`;
export var notice = `CYPTmuurDeg3Y2rE8GGQ`;
export var editorBody = `UP7I6H0Hu7du7DVlmm1Q`;
export var formatChoices = `iNCfQKhZqFc_omlF2Bl2`;
export var formatChoice = `Q_swukO1eFeETY37WX99`;
export default ___CSS_LOADER_EXPORT___;
